export default __webpack_public_path__ + "static/Mattress-Removal-1842a2e950f18c5cda85e315f27c84f0.jpg";